<template>
    <b-overlay
        :no-fade="noFade"
        :no-wrap="noWrap"
        :opacity="opacity"
        :rounded="rounded"
        :show="show"
        :spinner-type="spinnerType"
        :variant="color"
        :z-index="zIndex"
    >
        <slot />
    </b-overlay>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'

export default {
    components: { BOverlay },
    props: {
        color: {type: String, default: 'white'},
        noFade: {type: Boolean},
        noWrap: {type: Boolean},
        opacity: {type: [Number, String], default: 0.85},
        rounded: {type: [Boolean, String]},
        show: {type: Boolean},
        spinnerType: {type: String, default: 'border'},
        zIndex: {type: [Number, String], default: 900},
    },
}
</script>